<div class="contact-page" @fadeInAnimation>
  <div class="contact-page-title">
    <span class="title" [innerHTML]="'SERVICE.CONTACT.TITLE' | translate"></span>
  </div>
  <div class="contact-page-content">
    <div class="contact-form">
      <app-contact-form [isSaving]="isSaving" (sendForm)="sendForm($event)"></app-contact-form>
    </div>
    <div class="service-boxes">
      <app-service-boxes></app-service-boxes>
    </div>
  </div>
</div>
